import { setAttributes } from "../../utilities/index.js";
function calculateIndicatorSvgAttributes() {
  const diameter = 24;
  const radius = diameter / 2;
  return {
    // `circle` refers to the circle child node of the svg node
    circle: {
      cx: radius,
      cy: radius,
      r: radius
    },
    // `container` refers to the svg node
    container: {
      viewBox: `0 0 ${diameter} ${diameter}`
    }
  };
}
function initIndicators() {
  const xmlns = "http://www.w3.org/2000/svg";
  const indicators = Array.from(document.querySelectorAll(".tds-indicator"));
  const singleIndicators = indicators.filter(
    (indicator) => !indicator.parentElement?.classList?.contains("tds-indicator-group")
  );
  singleIndicators.forEach((indicator) => {
    const { circle: circleAttrs, container: containerAttrs } = calculateIndicatorSvgAttributes();
    setAttributes(indicator, containerAttrs);
    const circle = document.createElementNS(xmlns, "circle");
    circle.setAttribute("fill", "var(--tds-status-color--background-color)");
    setAttributes(circle, circleAttrs);
    indicator.append(circle);
  });
}
export {
  calculateIndicatorSvgAttributes,
  initIndicators
};
